export default "__VITE_ASSET__CEuwOPT2__"